import { ajax, AjaxConfig, AjaxResponse } from 'rxjs/ajax';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { getAccessToken } from 'services/auth';
import { RequestOptions, Response } from 'services/http';
import { saveFile } from 'utils/file';
import { extractFileName, handleError, handleErrorBlob } from './http.util';

const defaultHeaders = {
  'Content-Type': 'application/json',
};

export class Http {
  public static request<Data = any>(requestOpts: RequestOptions) {
    let accessToken: string | undefined = '';

    if (typeof window !== 'undefined') {
      accessToken = getAccessToken();
    }

    const ajaxConfig: AjaxConfig = {
      async: true,
      crossDomain: true,
      responseType: 'json',
      timeout: 100000,
      withCredentials: false,
      ...requestOpts,
      headers: requestOpts.headers ? requestOpts.headers : defaultHeaders,
    };

    if (accessToken) {
      (ajaxConfig as any).headers['Authorization'] = `Bearer ${accessToken}`;
    }

    return ajax(ajaxConfig).pipe(
      catchError(handleError(requestOpts)),
      map<AjaxResponse<any>, Response<Data>>((res) => res.response)
    );
  }

  public static upload<Data = any>(requestOpts: RequestOptions) {
    let accessToken: string | undefined = '';

    if (typeof window !== 'undefined') {
      accessToken = getAccessToken();
    }

    const ajaxConfig: AjaxConfig = {
      async: true,
      crossDomain: true,
      responseType: 'json',
      timeout: 100000,
      withCredentials: false,
      ...requestOpts,
      headers: {},
    };

    if (accessToken) {
      (ajaxConfig as any).headers['Authorization'] = `Bearer ${accessToken}`;
    }

    return ajax(ajaxConfig).pipe(
      catchError(handleError(requestOpts)),
      map<AjaxResponse<any>, Response<Data>>((res) => res.response)
    );
  }

  public static uploadMulti(requestOpts: RequestOptions) {
    let accessToken: string | undefined = '';

    if (typeof window !== 'undefined') {
      accessToken = getAccessToken();
    }

    const ajaxConfig: AjaxConfig = {
      async: true,
      crossDomain: true,
      responseType: 'json',
      timeout: 100000,
      withCredentials: false,
      ...requestOpts,
      headers: {},
    };

    if (accessToken) {
      (ajaxConfig as any).headers['Authorization'] = `Bearer ${accessToken}`;
    }

    return ajax(ajaxConfig).pipe(
      catchError(handleError(requestOpts)),
      map((res) => res)
    );
  }

  public static download(requestOpts: RequestOptions) {
    let accessToken: string | undefined = '';

    if (typeof window !== 'undefined') {
      accessToken = getAccessToken();
    }

    const ajaxConfig: AjaxConfig = {
      async: true,
      crossDomain: true,
      responseType: 'blob',
      timeout: 100000,
      withCredentials: false,
      ...requestOpts,
      headers: requestOpts.headers ? requestOpts.headers : defaultHeaders,
    };

    if (accessToken) {
      (ajaxConfig as any).headers['Authorization'] = `Bearer ${accessToken}`;
    }

    return ajax(ajaxConfig).pipe(
      mergeMap(async (res) => {
        saveFile(res.response as Blob, requestOpts.fileName ? requestOpts.fileName : extractFileName(res));

        return res;
      }),
      catchError(handleErrorBlob(requestOpts))
    );
  }
}
